import { SignInAndUp } from 'supertokens-auth-react/recipe/emailpassword/prebuiltui';

/**
 * Register Page
 *
 * Uses SuperTokens pre-built UI for user registration.
 * SuperTokens handles the switch between sign-in and sign-up.
 */
export function RegisterPage() {
  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-header">
          <h1>Wandool</h1>
          <p>Create your account</p>
        </div>
        <SignInAndUp />
      </div>
    </div>
  );
}

export default RegisterPage;
